import React, { useEffect, useState, useRef } from 'react'
import cssLessonIllustration from './LessonIllustration.module.scss'
import Card from '../../LUUtils/Card/Card';
import { CardBackgroundEnum } from '../../LUUtils/Card/Card';
import { GoToLUSinceActionEnum } from '../../LearningUnit.js';
// import GoogleShareToClassRoom from '../../../Utils/GShare.js'
import {ClientGatewayInPackage, GoogleShareToClassRoom, GlobalLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "LessonIllustration"
const INDEX_NONE = -1 // 未播放
// const PRELOAD_AUDIO_PREFIX_FOR_SENTENCE = "SentenceAudio"
// const PRELOAD_AUDIO_PREFIX_FOR_PAGE = "IlluContents"
// #endregion Constant

// #region Enumeration
const ResourceTypeEnum = {
    Image: 1,
    Audio: 2,
    Video: 3
}

const PlayingStatusEnum = {
    Playing: 1,
    Paused: 2,
    Stop: 3
}

const PlayingModeEnum = {
    None: 0,
    PlayOne: 1,
    PlayAll: 2
}

const IlluImageTypeEnum = {
    IlluMainFN: 1,
    IlluMajorFN: 2,
    IlluMinorFN: 3,
    IlluPinyinFN: 4
}
// #endregion Enumeration

// #region Member Variables
let mblnInitialized = false
let mintStateCurrentPageIndex = 0 // Index of SubCategory, ListOfContent, SuperQuestion or IlluContents
let mintTotalPages = 0 // 此LU內 若有Multiple Page 則 在此紀錄共有幾個Page
let mintChangeAnimationType = 0 // 0:window.gChangeAnimationTypeEnum.None, 決定Card動畫是 由左而右 或 由右而左
// let mstrLUCatSeqNo = "" // LUType
let mstrBookCatID = ""
let mstrLUCatSeqNo = ""

let mintAudioPlayingMode = PlayingModeEnum.None
let mintAudioPlayingStatus = PlayingStatusEnum.Stop
let mintIndexSentenceAudioPlaying = INDEX_NONE

// #region Original Image and Thumbnail
let marrIllustrationImage = [] // 呈顯用的Images 一開始初始化時使用Thumbnail 待圖片Laod完後用 Original Image
// #endregion Original Image and Thumbnail

// #region Preload audio
// let marrSentenceAudioManifestForPreload = [] // Sentence音檔清單的資訊
// let marrPreloadedAudio = [] // 已經Preload好的音檔 放在此Array中
// let mstrCurrentSoundName = "" // 用於 離開LU的時候 停止播放音檔
// #endregion Preload audio

// #region Preload image
let marrImageManifestForPreload = [] // 做Preload的Image
let mobjImageLoaded = { // 哪一個語系的Image已經Preload完成
    Major: false, // 預設未完成
    Minor: false // 預設未完成
}
// #endregion Preload image

// #endregion Member Variables

function LessonIllustration(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [showImagePinyin, setShowImagePinyin] = useState(true)
    const [showImageCharacters, setShowImageCharacters] = useState(true)
    const [currentPageIndex, setCurrentPageIndex] = useState(0)
    const [updateDataTime, setUpdateDataTime] = useState(0)
    // #endregion Init State

    // #region Init Ref
    // #endregion Init Ref

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    let mrefCleanUp = useRef(null)

    mrefPaintedMe.current = PaintedMe
    mrefCleanUp.current = CleanUp
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        console.log("GoToLUSinceActionEnum: ", GoToLUSinceActionEnum)
        console.log("GoToLUSinceAction: ", props.GoToLUSinceAction)

        mblnInitialized = true
        mintTotalPages = props.LUInfo.IlluContents.length
        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        mstrLUCatSeqNo = props.LUInfo.LUCatSeqNo

        // 第一次進入LU時 判斷是用點擊/上一頁/下一頁進來的 而給予不同的<Card />動畫
        switch (props.GoToLUSinceAction)
        {
            case GoToLUSinceActionEnum.Default:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.None
                setCurrentPageIndex(0)
                break;
            case GoToLUSinceActionEnum.GoPrev:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.Prev
                setCurrentPageIndex(mintTotalPages - 1)
                break;
            case GoToLUSinceActionEnum.GoNext:
                mintChangeAnimationType = window.gChangeAnimationTypeEnum.Next
                setCurrentPageIndex(0)
                break;
            default:
                break;
        }
    }
    // #endregion First Launch

    // #region useEffect
    useEffect(() => {
        mintStateCurrentPageIndex = currentPageIndex
    }, [currentPageIndex])

    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            mrefCleanUp.current()
        }
    }, [])
    // #endregion useEffect

    // #region Painted Me
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe: ")

        // 註冊Multiple Page中的上/下一頁事件
        let objCallbackData = {
            "Action": "InitCalledInfoInMultiPagedLU",
            "NextOnTapHandlerRef": LUNextPageHandler,
            "PrevOnTapHandlerRef": LUPrevPageHandler,
            "CanBePrev": (mintStateCurrentPageIndex > 0), // Multiple Page 非第一頁才為ture 
            "CanBeNext": (mintStateCurrentPageIndex < mintTotalPages - 1) // Multiple Page 非最後一頁才會true
        }
        props.CallbackRef(objCallbackData)

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)

        RegisterLanguageChangeHandler()
        RegisterGlossaryCallback()

        InitProcessBegin()
    }

    function CleanUp()
    {
        console.log(COMP_NAME + ".CleanUp: ")
        mblnInitialized = false
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
        window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        UnregisterLanguageChangeHandler()
        UnregisterGlossaryCallback()
        StopAudioAndResetPlayingIndex()
        // marrSentenceAudioManifestForPreload = []
        // marrPreloadedAudio = []
        marrIllustrationImage = []
        marrImageManifestForPreload = []
        mobjImageLoaded = {
            Major: false, // 預設未完成
            Minor: false // 預設未完成
        }
        window.AudioLibs.StopAudio()
    }
    // #endregion Painted Me

    // #region OnTapHandler
    function DisplayPinyinTextOnTapHandler(IsShow) {
        console.log(COMP_NAME + ".DisplayPinyinTextOnTapHandler")
        setShowImagePinyin(IsShow)
    }

    function DisplayCharactersTextOnTapHandler(IsShow) {
        console.log(COMP_NAME + ".DisplayCharactersTextOnTapHandler")        
        setShowImageCharacters(IsShow)
    }
    // #endregion OnTapHandler

    // #region Other Handler
    function LanguageOnChangeHandler()
    {
        console.log(COMP_NAME + ".LanguageOnChangeHandler: ")
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            console.log("Change to Major")
            if(!mobjImageLoaded.Major)
            {
                // Preload Major的圖片
                PreloadImageProcessBegin()
            }
        }
        else if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Minor)
        {
            console.log("Change to Minor")
            if(!mobjImageLoaded.Minor)
            {
                // Preload Minor的圖片
                PreloadImageProcessBegin()
            }
        }
    }

    // #region LU Change page within multiple page
    function LUPrevPageHandler()
    {
        console.log(COMP_NAME + ".LUPrevPageHandler: ")

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
        console.log("mintTotalPages: ", mintTotalPages)

        StopAudioAndResetPlayingIndex()

        if (mintStateCurrentPageIndex > 0)
        {
            // 目前在Multiple Page中 的非第一頁 點擊上一頁
            console.log("Prev is clicked, let's go to Prev page")
            mintChangeAnimationType = window.gChangeAnimationTypeEnum.Prev // 動畫新的畫面 由右往左出現
            // mintCurrentPageIndex--
            let intPageIndex = mintStateCurrentPageIndex - 1
            setCurrentPageIndex(intPageIndex)

            let objCallbackData = {
                "Action": "UpdateCanBeNavigatedInMultiPagedLU",
                "CanBePrev": (intPageIndex > 0),
                "CanBeNext": (intPageIndex < mintTotalPages - 1)
            }
            props.CallbackRef(objCallbackData)
        }
        else
        {
            // richard: 20211110 因為有 CanBeNext, parent 加判斷就不會發生
            // LU內有Multiple Page中 已在第一頁時 點擊上一頁
            console.log("Prev is clicked in the 1st page, let's inform parent")
            console.log("不應該發生")
        }
    }

    function LUNextPageHandler()
    {
        console.log(COMP_NAME + ".LUNextPageHandler: ")

        console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
        console.log("mintTotalPages: ", mintTotalPages)

        StopAudioAndResetPlayingIndex()

        if (mintStateCurrentPageIndex < mintTotalPages - 1)
        {
            // LU內有Multiple Page 在非最後一頁時 點擊下一頁
            console.log("Next is clicked, let's go to next page")
            mintChangeAnimationType = window.gChangeAnimationTypeEnum.Next // 動畫新的畫面 由左往右出現
            // mintCurrentPageIndex++
            let intPageIndex = mintStateCurrentPageIndex + 1
            setCurrentPageIndex(intPageIndex)

            let objCallbackData = {
                "Action": "UpdateCanBeNavigatedInMultiPagedLU",
                "CanBePrev": (intPageIndex > 0),
                "CanBeNext": (intPageIndex < mintTotalPages - 1)
            }
            props.CallbackRef(objCallbackData)
        }
        else
        {
            // richard: 20211110 因為有 CanBeNext, parent 加判斷就不會發生
            console.log("Next is clicked in the last page, let's inform parent")
            console.log("不應該發生")    
        }
    }
    // #endregion LU Change page within multiple page

    // #region Preload Audio

    /*

    // 已讀取完Question Audio後的處理
    function SentenceAudioLoadedHandler(SoundObject, ManifestIndexLoaded)
    {
        console.log(COMP_NAME + ".SentenceAudioLoadedHandler: ", SoundObject, ManifestIndexLoaded)

        if (ManifestIndexLoaded < (marrSentenceAudioManifestForPreload.length - 1))
        {
            // 讀下一個Sentence Audio
            PreloadSentenceAudio(ManifestIndexLoaded + 1)
        }
        else
        {
            // 已讀完所有Sentence Audio
            PreloadSentenceAudiosProcessEnd()
        }
    }

    */

    // #endregion Preload Audio

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
    }
    
    // #endregion Other Handler

    // #region LoadingMask and Alert
    // function OpenLoadingMask(LoadingMsg)
    // {
    //     console.log("OpenLoadingMask: ", LoadingMsg)

    //     let objCallbackData = {
    //         "Action": "OpenLoadingMask",
    //         "Message": LoadingMsg
    //     }
    //     props.CallbackRef(objCallbackData)
    // }

    // function CloseLoadingMask()
    // {
    //     console.log(COMP_NAME + ".CloseLoadingMask")

    //     let objCallbackData = {
    //         "Action": "CloseLoadingMask"
    //     }
    //     props.CallbackRef(objCallbackData)
    // }
    // #endregion LoadingMask and Alert

    // #region Toast
    // #endregion Toast

    // #region Component Callback
    function GlossaryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".GlossaryWindowCallback.CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "CloseShowGlossary")
        {
            console.log("GlossaryWindowCallback.CloseShowGlossary")
            RegisterAudioEvent() // 因為開啟GlossaryWindow時 Audio Event被註冊過去 所以關閉GlossaryWindow時 要再註冊回此
        }
    }
    // #endregion Component Callback

    // #region Other Functions

    function StopAudioAndResetPlayingIndex()
    {
        console.log(COMP_NAME + ".StopAudioAndResetPlayingIndex")

        /*
        if (mstrCurrentSoundName !== "")
        {
            AudioContextStopSound(mstrCurrentSoundName) // Preload Audio 的停止播放
        }
        */
        window.AudioLibs.StopAudio() // 直接停止播放

        mintAudioPlayingMode = PlayingModeEnum.None
        mintAudioPlayingStatus = PlayingStatusEnum.Stop
        mintIndexSentenceAudioPlaying = INDEX_NONE
    }

    function InitProcessBegin()
    {
        console.log(COMP_NAME + ".InitProcessBegin: ")

        InitImagesWithThumbnail()
        setUpdateDataTime(new Date().getTime())

        PreloadImageProcessBegin()
    }

    function InitImagesWithThumbnail()
    {
        console.log(COMP_NAME + ".InitImagesWithThumbnail: ")
        // 用小圖初始化
        marrIllustrationImage = []
        props.LUInfo.IlluContents.forEach((IllustrationContent) => {
            let objImageSet = {
                IlluMainFN: window.Globals.GetImageThumbnailURL(props.LessonID, IllustrationContent.IlluMainFN), // "01001_illustration_main_01.png"
                IlluMajorFN: window.Globals.GetImageThumbnailURL(props.LessonID, IllustrationContent.IlluMajorFN), // "01001_illustration_major_01.png"
                IlluMinorFN: window.Globals.GetImageThumbnailURL(props.LessonID, IllustrationContent.IlluMinorFN), // "01001_illustration_minor_01.png"
                IlluPinyinFN: window.Globals.GetImageThumbnailURL(props.LessonID, IllustrationContent.IlluPinyinFN) // "01001_illustration_pinyin_01.png"
            }
            marrIllustrationImage.push(objImageSet)
        })
        console.log("marrIllustrationImage: ", marrIllustrationImage)
    }

    // function InitProcessEnd()
    // {
    //     console.log(COMP_NAME + ".InitProcessEnd")
    // }

    // #region Preload Image
    
    // Get image info for preload image
    function GetImageManifest()
    {
        console.log(COMP_NAME + ".GetImageManifest: ")

        let arrManifest = []

        props.LUInfo.IlluContents.forEach((IlluContentItem, IlluContentIndex) =>
        {
            let strImageUrlIlluMainFN = window.Globals.GetResourceUrl(null, props.LessonID, ResourceTypeEnum.Image, IlluContentItem.IlluMainFN)
            if(
                (typeof(strImageUrlIlluMainFN) !== "undefined") &&
                (strImageUrlIlluMainFN !== null)
            )
            {
                arrManifest.push({
                    PageIndex: IlluContentIndex,
                    IlluImageType: IlluImageTypeEnum.IlluMainFN,
                    Src: strImageUrlIlluMainFN
                })
            }
            
            if(window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
            {
                // Load Major的圖
                let strImageUrlIlluMajorFN = window.Globals.GetResourceUrl(null, props.LessonID, ResourceTypeEnum.Image, IlluContentItem.IlluMajorFN)
                if(
                    (typeof(strImageUrlIlluMajorFN) !== "undefined") &&
                    (strImageUrlIlluMajorFN !== null)
                )
                {
                    arrManifest.push({
                        PageIndex: IlluContentIndex,
                        IlluImageType: IlluImageTypeEnum.IlluMajorFN,
                        Src: strImageUrlIlluMajorFN
                    })
                }
            }
            else if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Minor)
            {
                // Load Minor的圖
                let strImageUrlIlluMinorFN = window.Globals.GetResourceUrl(null, props.LessonID, ResourceTypeEnum.Image, IlluContentItem.IlluMinorFN)
                if(
                    (typeof(strImageUrlIlluMinorFN) !== "undefined") &&
                    (strImageUrlIlluMinorFN !== null)
                )
                {
                    arrManifest.push({
                        PageIndex: IlluContentIndex,
                        IlluImageType: IlluImageTypeEnum.IlluMinorFN,
                        Src: strImageUrlIlluMinorFN
                    })
                }
            }

            let strImageUrlIlluPinyinFN = window.Globals.GetResourceUrl(null, props.LessonID, ResourceTypeEnum.Image, IlluContentItem.IlluPinyinFN)
            if(
                (typeof(strImageUrlIlluPinyinFN) !== "undefined") &&
                (strImageUrlIlluPinyinFN !== null)
            )
            {
                arrManifest.push({
                    PageIndex: IlluContentIndex,
                    IlluImageType: IlluImageTypeEnum.IlluPinyinFN,
                    Src: strImageUrlIlluPinyinFN
                })
            }
        })
        console.log("GetImageManifest.arrManifest: ", arrManifest)
        return arrManifest
    }

    // Start processing preload image
    function PreloadImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadImageProcessBegin: ")

        marrImageManifestForPreload = GetImageManifest()
        console.log("marrImageManifestForPreload: ", marrImageManifestForPreload)
        if (marrImageManifestForPreload.length > 0)
        {
            LoadImage(0) // 從marrImageManifestForPreload的第一筆開始
        }
        else
        {
            PreloadImageProcessEnd()
        }
    }

    // Finished processing preload image
    function PreloadImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadImageProcessEnd: ")

        if(window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            // Major的Image Preload完成
            mobjImageLoaded.Major = true
        }
        else if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Minor)
        {
            // Minor的Image Preload完成
            mobjImageLoaded.Minor = true
        }

        // PreloadSentenceAudiosProcessBegin()
    }

    // 讀取圖片
    function LoadImage(ImageManifestIndexForPreload)
    {
        console.log(COMP_NAME + ".LoadImage: ", ImageManifestIndexForPreload)

        let objImage = new Image()
        objImage.onload = function ()
        {
            ImageLoadedHandler(ImageManifestIndexForPreload)
        };
        objImage.src = marrImageManifestForPreload[ImageManifestIndexForPreload].Src
    }

    // 圖片讀取完成後要做的處理
    function ImageLoadedHandler(ImageManifestIndexForPreload)
    {
        console.log(COMP_NAME + ".ImageLoadedHandler: ", ImageManifestIndexForPreload)

        console.log(COMP_NAME + " marrImageManifestForPreload:", marrImageManifestForPreload)
        
        // 避免不同LU之間 快速切換過程中 marrImageManifestForPreload 被 CleanUp清空後 仍跑到此function
        // 避免 ImageLoadedHandler 觸發的時候 已經換到其他頁了
        if(marrIllustrationImage.length > 0)
        {
            let intPageIndex = marrImageManifestForPreload[ImageManifestIndexForPreload].PageIndex
            let strSrc = marrImageManifestForPreload[ImageManifestIndexForPreload].Src
            console.log("intPageIndex: ", intPageIndex)
            console.log("strSrc: ", strSrc)

            switch(marrImageManifestForPreload[ImageManifestIndexForPreload].IlluImageType)
            {
                case IlluImageTypeEnum.IlluMainFN: 
                    marrIllustrationImage[intPageIndex].IlluMainFN = strSrc
                    break
                case IlluImageTypeEnum.IlluMajorFN: 
                    marrIllustrationImage[intPageIndex].IlluMajorFN = strSrc
                    break
                case IlluImageTypeEnum.IlluMinorFN: 
                    marrIllustrationImage[intPageIndex].IlluMinorFN = strSrc
                    break
                case IlluImageTypeEnum.IlluPinyinFN: 
                    marrIllustrationImage[intPageIndex].IlluPinyinFN = strSrc
                    break
                default:
                    break
            }
        }
        console.log("marrIllustrationImage image loaded: ", marrIllustrationImage)
        setUpdateDataTime(new Date().getTime())

        GotoNextLoadImage(ImageManifestIndexForPreload)
    }

    // 讀取下一張圖片
    function GotoNextLoadImage(ImageManifestIndexForPreload)
    {
        console.log(COMP_NAME + ".GotoNextLoadImage: ", ImageManifestIndexForPreload)

        if(ImageManifestIndexForPreload < (marrImageManifestForPreload.length - 1))
        {
            ImageManifestIndexForPreload++
            LoadImage(ImageManifestIndexForPreload)
        }
        else
        {
            PreloadImageProcessEnd()
        }
    }
    // #endregion Preload Image

    

    // #region Preload Audio
    /*
    // Start processing preloading sentence audio
    function PreloadSentenceAudiosProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadSentenceAudiosProcessBegin: ")

        marrSentenceAudioManifestForPreload = GetSentenceAudiosManifest()
        console.log("marrSentenceAudioManifestForPreload: ", marrSentenceAudioManifestForPreload)
        PreloadSentenceAudio(0) // 從第一個 ManifestIndex:0 開始做Preload Audio
    }

    // Finished processing preloading sentence audio
    function PreloadSentenceAudiosProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadSentenceAudiosProcessEnd")
        
        InitProcessEnd()
    }

    // Get sentence audio info for preload audio    
    function GetSentenceAudiosManifest()
    {
        console.log(COMP_NAME + ".GetSentenceAudiosManifest")

        console.log("props.LUInfo.IlluContents[mintStateCurrentPageIndex].Sentence[0].AudioFN: ", props.LUInfo.IlluContents[mintStateCurrentPageIndex].Sentence[0].AudioFN)

        let arrManifest = []

        let intIlluContentsPageIndex = 0
        let intIlluContentsLength = props.LUInfo.IlluContents.length
        for (intIlluContentsPageIndex = 0; intIlluContentsPageIndex < intIlluContentsLength; intIlluContentsPageIndex++)
        {
            let intSentenceIndex = 0
            let intSentenceLength = props.LUInfo.IlluContents[intIlluContentsPageIndex].Sentence.length

            for (intSentenceIndex = 0; intSentenceIndex < intSentenceLength; intSentenceIndex++)
            {
                let strAudioUrl = ""
                let strAudioFN = props.LUInfo.IlluContents[intIlluContentsPageIndex].Sentence[intSentenceIndex].AudioFN
                console.log("strAudioFN: ", strAudioFN)
                strAudioUrl = window.Globals.GetResourceUrl(null, props.LessonID, window.gResourceTypeEnum.Audio, strAudioFN)
                console.log("strAudioUrl: ", strAudioUrl)

                arrManifest.push({
                    Name: PRELOAD_AUDIO_PREFIX_FOR_PAGE + intIlluContentsPageIndex.toString() + PRELOAD_AUDIO_PREFIX_FOR_SENTENCE + intSentenceIndex.toString(),
                    Src: strAudioUrl,
                    Callback: SentenceAudioLoadedHandler
                })
            }
        }
        console.log("arrManifest: ", arrManifest)
        return arrManifest
    }

    // Preload sentence audio
    function PreloadSentenceAudio(ManifestIndex)
    {
        console.log(COMP_NAME + ".PreloadSentenceAudio: ", ManifestIndex)

        AudioContextLoadAudio(marrSentenceAudioManifestForPreload[ManifestIndex], ManifestIndex)
    }

    // Load Audio
    function AudioContextLoadAudio(SoundObject, ManifestIndex)
    {
        console.log(COMP_NAME + ".AudioContextLoadAudio: ", SoundObject, ManifestIndex)

        let objCallback = {
            "SoundObject": SoundObject,
            "ManifestIndex": ManifestIndex
        }
        marrPreloadedAudio[SoundObject.Name] = SoundObject // Call by reference
        window.AudioLibs.PreloadAudio(SoundObject.Src, objCallback)
    }

    // Stop playing preloaded audio
    function AudioContextStopSound(SoundName)
    {
        console.log(COMP_NAME + ".AudioContextStopSound: ", SoundName)

        console.log("marrPreloadedAudio: ", marrPreloadedAudio)
        console.log("marrPreloadedAudio[SoundName]: ", marrPreloadedAudio[SoundName])
        if (marrPreloadedAudio[SoundName])
        {
            // Stop audio
            mstrCurrentSoundName = ""
            window.AudioLibs.StopAudio()
        }
    }

    // Playing preloaded audio
    function AudioContextPlaySound(SoundName)
    {
        console.log(COMP_NAME + ".AudioContextPlaySound: ", SoundName)

        console.log("marrPreloadedAudio: ", marrPreloadedAudio)
        console.log("marrPreloadedAudio[SoundName]: ", marrPreloadedAudio[SoundName])
        if (marrPreloadedAudio[SoundName])
        {
            mstrCurrentSoundName = SoundName
            window.AudioLibs.PlayAudio(marrPreloadedAudio[SoundName].Src)
        }
    }

    // Play preloaded audio by index
    function PlayPreloadedSentenceAudio(CurrentPageIndex, IndexSentenceAudio)
    {
        console.log(COMP_NAME + ".PlayPreloadedSentenceAudio: ", CurrentPageIndex, IndexSentenceAudio)
        AudioContextPlaySound(
            PRELOAD_AUDIO_PREFIX_FOR_PAGE + CurrentPageIndex.toString() +
            PRELOAD_AUDIO_PREFIX_FOR_SENTENCE + IndexSentenceAudio.toString()
        )
    }

    */

    // #endregion Preload Audio

    

    function RegisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".RegisterGlossaryCallback: ")
        // 因為ToolBarTopUnit點擊Glossary開啟後 會搶走AudioEnded, AudioCanPlay事件 所以如果LU有使用Audio Event 就必須在Glossary關閉時 需呼叫mobjCallerInfoForGlossaryWindow.CallbackRef 觸發 讓Audio Event再次註冊到LU
        let objCallbackData = {
            "Action": "RegisterGlossaryCallback",
            "CallbackRef": GlossaryWindowCallback
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterGlossaryCallback()
    {
        console.log(COMP_NAME + ".UnregisterGlossaryCallback: ")
        let objCallbackData = {
            "Action": "UnregisterGlossaryCallback"
        }
        props.CallbackRef(objCallbackData)
    } 

    function RegisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    }

    function UnregisterLanguageChangeHandler()
    {
        console.log(COMP_NAME + ".UnregisterLanguageChangeHandler: ")
        let objCallbackData = {
            "Action": "UnregisterLanguageChangeHandler"
        }
        props.CallbackRef(objCallbackData)
    }
    
    /*===========================================
    summary: 點選 GoogleClassroom 元件
    remarks: 000 Jeff 20XX/XX/XX Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function Share2GoogleClassroom4AppOnTapHandler()
    {
        console.log(COMP_NAME + ".Share2GoogleClassroom4AppOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(props.LUInfo.LUCatSeqNo)
        console.log("Share2GoogleClassroom4AppOnTapHandler strUrl: ", encodeURIComponent(strUrl))

        // In App
        let intAction = window.gConst.ACTION_OEPN_APP_SHARE_WITH_URL;
        let intPositionX = 54 // 視窗的小箭頭位置
        let intPositionY = 112 // 視窗的小箭頭位置
        
        let strQueryString = "Action=" + intAction
        strQueryString += "&Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&Url=" + encodeURIComponent(strUrl)
        strQueryString += "&PosX=" + intPositionX.toString()
        strQueryString += "&PosY=" + intPositionY.toString()

        console.log("Share2GoogleClassroom4AppOnTapHandler strQueryString: ", strQueryString)

        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of Share2GoogleClassroom4AppOnTapHandler

    function PlayAudioCanPlayHandler()
    {
        console.log(COMP_NAME + ".PlayAudioCanPlayHandler: ")
    }

    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler: ")

        // mstrCurrentSoundName = ""
        
        if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
        {
            mintIndexSentenceAudioPlaying = INDEX_NONE
            mintAudioPlayingStatus = PlayingStatusEnum.Stop
            mintAudioPlayingMode = PlayingModeEnum.None
        }
        else if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
        {
            console.log("mintIndexSentenceAudioPlaying: ", mintIndexSentenceAudioPlaying)
            console.log("mintStateCurrentPageIndex: ", mintStateCurrentPageIndex)
            console.log("props.LUInfo: ", props.LUInfo)
            if (mintIndexSentenceAudioPlaying < (props.LUInfo.IlluContents[mintStateCurrentPageIndex].Sentence.length - 1))
            {
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                mintIndexSentenceAudioPlaying++
                // PlayPreloadedSentenceAudio(mintStateCurrentPageIndex, mintIndexSentenceAudioPlaying)
                StartPlayOne(mintStateCurrentPageIndex, mintIndexSentenceAudioPlaying)
            }
            else if (mintIndexSentenceAudioPlaying === (props.LUInfo.IlluContents[mintStateCurrentPageIndex].Sentence.length - 1))
            {
                console.log("PlayAll last audio paly end")
                // 播完最後一的音檔
                mintIndexSentenceAudioPlaying = INDEX_NONE
                mintAudioPlayingStatus = PlayingStatusEnum.Stop
                mintAudioPlayingMode = PlayingModeEnum.None
            }
        }
        setUpdateDataTime(new Date().getTime())
    }

    function PlayAllOrPauseAllAudioOnTapHandler(StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".PlayAllOrPauseAllAudioOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log("mintAudioPlayingMode:", mintAudioPlayingMode)
        console.log("mintIndexSentenceAudioPlaying:", mintIndexSentenceAudioPlaying)
        console.log("mintAudioPlayingStatus:", mintAudioPlayingStatus)
        
        if (mintAudioPlayingStatus === PlayingStatusEnum.Stop)
        {
            mintAudioPlayingMode = PlayingModeEnum.PlayAll
            // 目前為停止播放
            console.log("Stop => Play")
            mintIndexSentenceAudioPlaying = 0 // 從第一句開始播
            mintAudioPlayingStatus = PlayingStatusEnum.Playing
            // ScrollToSentence(mintIndexSentenceAudioPlaying)
            // PlayPreloadedSentenceAudio(StateCurrentPageIndex, mintIndexSentenceAudioPlaying) // Play peloaded audio
            StartPlayOne(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
        }
        else if (mintAudioPlayingStatus === PlayingStatusEnum.Paused)
        {
            // 目前為暫停播放中
            if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
            {
                console.log("Pause => Continue Playing all")
                // 若之前是在播放Play All的時候按暫停 點擊Play All 則繼續播放
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                window.AudioLibs.Play()
            }
            else if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
            {
                // 若之前是在播放Play One的時候按暫停時 點擊Play All 則從第一句開始播放
                console.log("Pause => Play all audio")
                mintAudioPlayingMode = PlayingModeEnum.PlayAll
                mintIndexSentenceAudioPlaying = 0 // 從第一句開始播
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                // PlayPreloadedSentenceAudio(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
                StartPlayOne(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
            }
        }
        else if (mintAudioPlayingStatus === PlayingStatusEnum.Playing)
        {
            // 目前為正在播放中
            if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
            {
                // 點擊時 正處於Playing all的Audio 則執行Pause
                mintAudioPlayingStatus = PlayingStatusEnum.Paused
                window.AudioLibs.PauseAudio()
            }
            else if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
            {
                // 點擊時 正處於Playing one的Audio 則從頭播放
                console.log("Play => Play all audio")
                mintAudioPlayingMode = PlayingModeEnum.PlayAll
                mintIndexSentenceAudioPlaying = 0 // 從第一句開始播
                // ScrollToSentence(mintIndexSentenceAudioPlaying)
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                // PlayPreloadedSentenceAudio(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
                StartPlayOne(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
            }
        }
        setUpdateDataTime(new Date().getTime())
    }

    function StopAllAudioOnTapHandler()
    {
        console.log(COMP_NAME + ".StopAllAudioOnTapHandler")

        StopAudioAndResetPlayingIndex()
        setUpdateDataTime(new Date().getTime())
    }

    // 播放某一個音檔
    function StartPlayOne(CurrentPageIndex, IndexSentenceAudioPlaying)
    {
        // 從頭開始播放某一特定音檔
        console.log(COMP_NAME + ".StartPlayOne: ", CurrentPageIndex, IndexSentenceAudioPlaying)
        // let strAudioFN = props.LUInfo.Sentence[Index].AudioFN
        let strAudioFN = props.LUInfo.IlluContents[CurrentPageIndex].Sentence[IndexSentenceAudioPlaying].AudioFN
        console.log("strAudioFN: ", strAudioFN)
        let strAudioUrl = window.Globals.GetResourceUrl(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Audio, strAudioFN)
        console.log("strAudioUrl: ", strAudioUrl)
        window.AudioLibs.PlayAudio(strAudioUrl)
    }

    function PlayOneAudioOnTapHandler(event, StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".PlayOneAudioOnTapHandler")

        // 按下後 延遲一下再切換 解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let objTarget = event.target
        let intSentenceIndex = parseInt(objTarget.getAttribute("sentenceindex")) // 此actiontype是在 RenderTouchZoneWrapper()中註記的
        console.log("PlayOneAudioOnTapHandler: intSentenceIndex:", intSentenceIndex)

        mintAudioPlayingMode = PlayingModeEnum.PlayOne
        if (mintAudioPlayingStatus === PlayingStatusEnum.Stop)
        {
            // 目前為停止播放
            console.log("Stop => Play")
            mintIndexSentenceAudioPlaying = intSentenceIndex
            mintAudioPlayingStatus = PlayingStatusEnum.Playing
            // PlayPreloadedSentenceAudio(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)

            StartPlayOne(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
        }
        else if (mintAudioPlayingStatus === PlayingStatusEnum.Paused)
        {
            if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
            {
                // 目前為暫停播放中
                if (mintIndexSentenceAudioPlaying === intSentenceIndex)
                {
                    console.log("Pause => Continue Playing")
                    // 點擊的是 正處於Paused的Audio 則 繼續播放
                    mintAudioPlayingStatus = PlayingStatusEnum.Playing
                    window.AudioLibs.Play()
                }
                else
                {
                    console.log("Pause => Play another audio")
                    // 點擊的是 非處於Paused的Audio 則 播放音檔
                    mintIndexSentenceAudioPlaying = intSentenceIndex
                    mintAudioPlayingStatus = PlayingStatusEnum.Playing
                    // PlayPreloadedSentenceAudio(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)

                    StartPlayOne(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
                }
            }
            else if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
            {
                // 若之前是在播放Play All的時候按暫停 則 播放音檔
                mintIndexSentenceAudioPlaying = intSentenceIndex
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                // ScrollToSentence(mintIndexSentenceAudioPlaying)
                // PlayPreloadedSentenceAudio(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)

                StartPlayOne(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
            }
        }
        else if (mintAudioPlayingStatus === PlayingStatusEnum.Playing)
        {
            if (mintAudioPlayingMode === PlayingModeEnum.PlayOne)
            {
                // 目前為正在播放Play One的音檔
                if (mintIndexSentenceAudioPlaying === intSentenceIndex)
                {
                    console.log("Playing => Pause")
                    // 點擊的是 正處於Playing的Audio 則 執行Paused
                    mintAudioPlayingStatus = PlayingStatusEnum.Paused
                    window.AudioLibs.PauseAudio()
                }
                else
                {
                    console.log("Playing => Play another audio")
                    // 點擊的是 非處於Playing的Audio 則 執行Playing
                    mintIndexSentenceAudioPlaying = intSentenceIndex
                    mintAudioPlayingStatus = PlayingStatusEnum.Playing
                    // PlayPreloadedSentenceAudio(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
                    StartPlayOne(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
                }
            }
            else if (mintAudioPlayingMode === PlayingModeEnum.PlayAll)
            {
                // 目前為正在播放Play All的音檔 則 執行播放
                mintIndexSentenceAudioPlaying = intSentenceIndex
                mintAudioPlayingStatus = PlayingStatusEnum.Playing
                // ScrollToSentence(mintIndexSentenceAudioPlaying)
                // PlayPreloadedSentenceAudio(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)

                StartPlayOne(StateCurrentPageIndex, mintIndexSentenceAudioPlaying)
            }
        }
        setUpdateDataTime(new Date().getTime())
    }
    // #endregion Other Functions

    // #region Get ClassName and Style
    
    function GetStyleTouchUnit(TouchUnitData)
    {
        // console.log(COMP_NAME + ".GetStyleTouchUnit: ", TouchUnitData);

        /*
        CMS給的圖 圖的實際大小
        "ORIGINAL_WIDTH": 1033
        "ORIGINAL_HEIGHT": 1435
        在Illustration呈現的大小
        "APP_WIDTH": 944         
        "APP_HEIGHT": 1311

        "mintAppHeight": 1435
        */

        let APP_HEIGHT = 1311
        // let APP_WIDTH = 944

        // let mintAppHeight = 1435

        // let ORIGINAL_WIDTH = 1033
        let ORIGINAL_HEIGHT = 1435

        let floatRatio = APP_HEIGHT / ORIGINAL_HEIGHT;

        // console.log("left parseInt(TouchUnitData[0]:", parseInt(TouchUnitData[0]) )
        // console.log("top parseInt(TouchUnitData[1]:", parseInt(TouchUnitData[1]) )
        // console.log("width parseInt(TouchUnitData[2]:", parseInt(TouchUnitData[2]) )
        // console.log("height parseInt(TouchUnitData[3]:", parseInt(TouchUnitData[3]) )

        // console.log("left parseInt(TouchUnitData[0]:",  (parseInt(TouchUnitData[0]) * floatRatio).toString() + 'px')  // 0: Left
        // console.log("top parseInt(TouchUnitData[1]:",   (parseInt(TouchUnitData[1]) * floatRatio).toString() + 'px')  // 1: Top
        // console.log("width parseInt(TouchUnitData[2]:", (parseInt(TouchUnitData[2]) * floatRatio).toString() + 'px')  // 2: Width
        // console.log("height parseInt(TouchUnitData[3]:",(parseInt(TouchUnitData[3]) * floatRatio).toString() + 'px') // 3: Height

        /*
        let strOriginalLeft = parseInt(TouchUnitData[0]) // 0: Left
        let strOriginalTop = parseInt(TouchUnitData[1]) // 1: Top
        let strOriginalWidth = parseInt(TouchUnitData[2]) // 2: Width
        let strOriginalHeight = parseInt(TouchUnitData[3]) // 3: Height
        console.log("GetStyleTouchUnit.strOriginalLeft:", strOriginalLeft)
        console.log("GetStyleTouchUnit.strOriginalTop:", strOriginalTop)
        console.log("GetStyleTouchUnit.strOriginalWidth:", strOriginalWidth)
        console.log("GetStyleTouchUnit.strOriginalHeight:", strOriginalHeight)
        */

        
        let strAdjustLeft = (parseInt(TouchUnitData[0]) * floatRatio).toString() + 'px'
        let strAdjustTop = (parseInt(TouchUnitData[1]) * floatRatio).toString() + 'px'
        let strAdjustWidth = (parseInt(TouchUnitData[2]) * floatRatio).toString() + 'px'
        let strAdjustHeight = (parseInt(TouchUnitData[3]) * floatRatio).toString() + 'px'
        // console.log("GetStyleTouchUnit.strAdjustLeft:", strAdjustLeft)
        // console.log("GetStyleTouchUnit.strAdjustTop:", strAdjustTop)
        // console.log("GetStyleTouchUnit.strAdjustWidth:", strAdjustWidth)
        // console.log("GetStyleTouchUnit.strAdjustHeight:", strAdjustHeight)
        

        // let objStyle = {
        //     left: strOriginalLeft, // 0: Left
        //     top: strOriginalTop, // 1: Top
        //     width: strOriginalWidth, // 2: Width
        //     height: strOriginalHeight // 3: Height
        // }

        let objStyle = {
            left: strAdjustLeft, // 0: Left
            top: strAdjustTop, // 1: Top
            width: strAdjustWidth, // 2: Width
            height: strAdjustHeight // 3: Height
        }

        return objStyle
    }

    function GetClsPinyinOn()
    {
        // console.log(COMP_NAME + ".GetClsPinyinOn")

        let objCls = cssLessonIllustration.divHeaderRightPinyinButtonOnDisable

        if (showImagePinyin)
        {
            objCls = cssLessonIllustration.divHeaderRightPinyinButtonOnEnable
        }

        return objCls
    }

    function GetClsPinyinOff()
    {
        // console.log(COMP_NAME + ".GetClsPinyinOff")

        let objCls = cssLessonIllustration.divHeaderRightPinyinButtonOffDisable

        if (!showImagePinyin)
        {
            objCls = cssLessonIllustration.divHeaderRightPinyinButtonOffEnable
        }

        return objCls
    }

    function GetClsCharactersOn()
    {
        // console.log(COMP_NAME + ".GetClsCharactersOn")

        let objCls = cssLessonIllustration.divHeaderRightCharactersButtonOnDisable

        if (showImageCharacters)
        {
            objCls = cssLessonIllustration.divHeaderRightCharactersButtonOnEnable
        }

        return objCls
    }

    function GetClsCharactersOff()
    {
        // console.log(COMP_NAME + ".GetClsCharactersOff")

        let objCls = cssLessonIllustration.divHeaderRightCharactersButtonOffDisable

        if (!showImageCharacters)
        {
            objCls = cssLessonIllustration.divHeaderRightCharactersButtonOffEnable
        }

        return objCls
    }

    function GetClsPlayAllOrPauseAllButton()
    {
        console.log(COMP_NAME + ".GetClsPlayAllOrPauseAllButton")

        let objCls = cssLessonIllustration.divHeaderRightPlayAllButtonPlayButton

        if (
            (mintAudioPlayingMode === PlayingModeEnum.PlayAll) &&
            (mintAudioPlayingStatus === PlayingStatusEnum.Playing)
            )
        {
            objCls = cssLessonIllustration.divHeaderRightPlayAllButtonPauseButton
        }

        return objCls
    }

    function GetClsStopAllButton()
    {
        // console.log(COMP_NAME + ".GetClsStopAllButton")

        let objCls = cssLessonIllustration.divHeaderButtonStopAllButtonDisable

        if (
            (mintAudioPlayingMode === PlayingModeEnum.PlayAll) &&
            (
                (mintAudioPlayingStatus === PlayingStatusEnum.Playing) ||
                (mintAudioPlayingStatus === PlayingStatusEnum.Paused)
                )
        )
        {
            objCls = cssLessonIllustration.divHeaderButtonStopAllButton
        }

        return objCls
    }
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    // #endregion Web Service After Process

    // #region Web Service
    // #endregion Web Service

    // #region Render
    
    function RenderGoogleClassrommButton()
    {
        let objBlockGoogleClassroomButton = null
        if (!window.gConfig.ForChina)
        {
            // 非China
            if (!window.gSession.App.InApp)
            {
                let strUrl = window.Globals.GenerateShare2GoogleClassroomUrl(mstrLUCatSeqNo)
                console.log("strUrl: ", encodeURIComponent(strUrl))            
                objBlockGoogleClassroomButton = <GoogleShareToClassRoom
                    itemType="assignment"
                    url={strUrl}
                    size={32}
                    theme="classic"
                />
            }
            else
            {
                // In App
                console.log("window.gSession.App.AppVersion:", window.gSession.App.AppVersion)
                var intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, "2.0.8.2");
                if(intCheckResult === -1)
                {
                    // DCP iOS App版號 2.0.8.1以前(含) e.g. iOS 2.0.8.1, 2.0.8.0, 2.0.7 ...
                    objBlockGoogleClassroomButton = null
                }
                else
                {
                    // DCP iOS App版號 2.0.8.2以後(含)
                    objBlockGoogleClassroomButton = <div className={cssLessonIllustration.btnShare2GoogleClassroom4App} onClick={() => Share2GoogleClassroom4AppOnTapHandler()} />
                }
            }
        }
        
        return objBlockGoogleClassroomButton
    }
    
    function RenderHeaderLeftArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderLeftArea");

        let strTitleEN = props.SubSectionDef.Name;
        let strTitleCN = '';
        if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
        {
            strTitleCN = props.SubSectionDef.MajorName;
        }
        else
        {
            strTitleCN = props.SubSectionDef.MinorName;
        }

        let strInstruction = ""
        if (
            (typeof (props.LUInfo.Instruction) !== 'undefined') &&
            (props.LUInfo.Instruction !== null) &&
            (props.LUInfo.Instruction !== "")
            )
        {
            strInstruction = props.LUInfo.Instruction;
        }

        return (
            <>
            <div className={cssLessonIllustration.divTitleLeftArea}>
                {RenderGoogleClassrommButton()}
                <div className={cssLessonIllustration.divTitleSubArea}>
                    <div className={cssLessonIllustration.divLessonIcon}></div>
                    <div className={cssLessonIllustration.divLUTitleTextEN}>
                        {strTitleEN}
                    </div>
                    <div className={cssLessonIllustration.divDividerBar}></div>
                    <div className={cssLessonIllustration.divLUTitleTextCN}>
                        {strTitleCN}
                    </div>
                </div>
            </div>
            <div className={cssLessonIllustration.divTitleLeftInstructionArea}>{strInstruction}</div>
            </>
        )
    }

    function RenderHeaderRightArea()
    {
        // console.log(COMP_NAME + ".RenderHeaderRightArea")
        return (
                <div className={cssLessonIllustration.divTitleAreaRight}>
                    <div className={cssLessonIllustration.divHeaderRightPinyinText}>{window.gAppUI.LBL_ShowPinyin}</div>
                    <div className={GetClsPinyinOff()} onClick={() => DisplayPinyinTextOnTapHandler(false)}>{window.gAppUI.BTN_OFF}</div>
                    <div className={GetClsPinyinOn()} onClick={() => DisplayPinyinTextOnTapHandler(true)}>{window.gAppUI.BTN_ON}</div>

                    <div className={cssLessonIllustration.divTitleRightBar}></div>

                    <div className={cssLessonIllustration.divHeaderRightCharactersText}>{window.gAppUI.LBL_ShowCharacters}</div>
                    <div className={GetClsCharactersOff()} onClick={() => DisplayCharactersTextOnTapHandler(false)}>{window.gAppUI.BTN_OFF}</div>
                    <div className={GetClsCharactersOn()} onClick={() => DisplayCharactersTextOnTapHandler(true)}>{window.gAppUI.BTN_ON}</div>
                    
                    <div className={cssLessonIllustration.divTitleRightBar}></div>

                    <div className={cssLessonIllustration.divHeaderRightPlayAllText}>{window.gAppUI.LBL_PlayAll}</div>
                    <div className={GetClsPlayAllOrPauseAllButton()} onClick={() => PlayAllOrPauseAllAudioOnTapHandler(currentPageIndex)}></div>
                    <div className={GetClsStopAllButton()} onClick={() => StopAllAudioOnTapHandler()}></div>
                </div>
        )
    }

    function RenderStoryPicture(StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".RenderStoryPicture");

        let objStyleIlluMainFN = {
            // backgroundImage: 'url(' + window.Globals.GetResourceUrl(null, props.LessonID, ResourceTypeEnum.Image, props.LUInfo.IlluContents[StateCurrentPageIndex].IlluMainFN) + ')'
            // backgroundImage: 'url(' + window.Globals.GetImageThumbnailURL(props.LessonID, props.LUInfo.IlluContents[StateCurrentPageIndex].IlluMainFN) + ')'
            backgroundImage: 'url(' + marrIllustrationImage[StateCurrentPageIndex].IlluMainFN + ')'
        }
        console.log("objStyleIlluMainFN: ", objStyleIlluMainFN)

        return (
            <div className={cssLessonIllustration.divImage} style={objStyleIlluMainFN}></div>
        )
    }

    function RenderImageCharacters(StateCurrentPageIndex)
    {
        console.log(COMP_NAME + ".RenderImageCharacters: ", StateCurrentPageIndex);

        let objDivMajorOrMinor = null

        if (showImageCharacters)
        {
            let objStyleIlluMajorOrMinorFN = null
            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
            {
                objStyleIlluMajorOrMinorFN = {
                    // backgroundImage: 'url(' + window.Globals.GetResourceUrl(null, props.LessonID, ResourceTypeEnum.Image, props.LUInfo.IlluContents[StateCurrentPageIndex].IlluMajorFN) + ')'
                    backgroundImage: 'url(' + marrIllustrationImage[StateCurrentPageIndex].IlluMajorFN + ')'
                }
            }
            else
            {
                objStyleIlluMajorOrMinorFN = {
                    // backgroundImage: 'url(' + window.Globals.GetResourceUrl(null, props.LessonID, ResourceTypeEnum.Image, props.LUInfo.IlluContents[StateCurrentPageIndex].IlluMinorFN) + ')'
                    backgroundImage: 'url(' + marrIllustrationImage[StateCurrentPageIndex].IlluMinorFN + ')'
                }
            }
            console.log("objStyleIlluMajorOrMinorFN: ", objStyleIlluMajorOrMinorFN)

            objDivMajorOrMinor = (
                <div className={cssLessonIllustration.divImage} style={objStyleIlluMajorOrMinorFN}></div>
            )
        }
        return objDivMajorOrMinor
    }

    function RenderImagePinyin(StateCurrentPageIndex)
    {
        // console.log(COMP_NAME + ".RenderImagePinyin");

        let objDivPinyin = null

        if (showImagePinyin)
        {
            let strStyleIlluPinyinFN = {
                // backgroundImage: 'url(' + window.Globals.GetResourceUrl(null, props.LessonID, ResourceTypeEnum.Image, props.LUInfo.IlluContents[StateCurrentPageIndex].IlluPinyinFN) + ')'
                backgroundImage: 'url(' + marrIllustrationImage[StateCurrentPageIndex].IlluPinyinFN + ')'
            }

            console.log("strStyleIlluPinyinFN: ", strStyleIlluPinyinFN)

            objDivPinyin = (
                <div className={cssLessonIllustration.divImage} style={strStyleIlluPinyinFN}></div>
            )
        }
        return objDivPinyin
    }

    function RenderTouchZoneWrapper(IllustrationContentsIndex, StateCurrentPageIndex)
    {
        // console.log(COMP_NAME + ".RenderTouchZoneWrapper: ", IllustrationContentsIndex, StateCurrentPageIndex)

        let objTouchArea = props.LUInfo.IlluContents[StateCurrentPageIndex].Sentence[IllustrationContentsIndex].TouchArea

        let objUnit = (
            <div className={cssLessonIllustration.divTouchArea}
                style={GetStyleTouchUnit(objTouchArea)}
                onClick={(event) => PlayOneAudioOnTapHandler(event, StateCurrentPageIndex)}
                sentenceindex={IllustrationContentsIndex}
            >
            </div>
        )

        return objUnit
    }

    function RenderCardContent()
    {
        console.log("marrIllustrationImage: ", marrIllustrationImage)
        return (
            <div className={cssLessonIllustration.divImageArea}>
                {RenderStoryPicture(currentPageIndex)}
                {RenderImageCharacters(currentPageIndex)}
                {RenderImagePinyin(currentPageIndex)}
                {props.LUInfo.IlluContents[currentPageIndex].Sentence.map((Result, Index) =>
                    <React.Fragment key={Index}>
                        {RenderTouchZoneWrapper(Index, currentPageIndex)}
                    </React.Fragment>
                )}
            </div>
            )
    }

    function RenderContentListWrapper(IllustrationContentsIndex)
    {
        // console.log(COMP_NAME + ".RenderContentListWrapper")

        let objBlock = null
        if(updateDataTime > 0)
        {
            if (props.LUInfo.IlluContents.length > 1)
            {
                console.log("Many pages")

                // 有多頁時 要用左右滑動的效果
                console.log("mstrBookCatID:", mstrBookCatID)
                console.log("currentPageIndex:", currentPageIndex)
                console.log("props.LUInfo.IlluContents:", props.LUInfo.IlluContents)

                objBlock = (
                    <Card
                    CardIndex={IllustrationContentsIndex}
                    ChangeAnimationType={mintChangeAnimationType}
                    CardBackground={CardBackgroundEnum.Default}
                    RenderContent={RenderCardContent()}
                />
                )
            }
            else if (props.LUInfo.IlluContents.length === 1)
            {
                console.log("One page")
                // 只有一頁
                objBlock = (<div className={cssLessonIllustration.divImageArea}>
                    {RenderStoryPicture(currentPageIndex)}
                    {RenderImageCharacters(currentPageIndex)}
                    {RenderImagePinyin(currentPageIndex)}

                    {props.LUInfo.IlluContents[currentPageIndex].Sentence.map((Result, Index) =>
                        <div key={Index}>
                            {RenderTouchZoneWrapper(Index, currentPageIndex)}
                        </div>
                    )}

                </div>)
            }
        }
        
        
        return objBlock
    }

    function GetPageIconCls(Index, CurrentIlluContentsIndex)
    {
        console.log(COMP_NAME + ".GetPageIconCls");
        console.log("GetPageIconCls: Index:", Index)
        console.log("GetPageIconCls: CurrentIlluContentsIndex:", CurrentIlluContentsIndex)

        let objCls = cssLessonIllustration.divPageIconUnSelect

        if (Index === CurrentIlluContentsIndex)
        {
            console.log("GetPageIconCls: divPageIconSelected")
            objCls = cssLessonIllustration.divPageIconSelected
        }

        return objCls
    }

    function RenderPageIcon()
    {
        console.log(COMP_NAME + ".RenderPageIcon: ")
        if (props.LUInfo.IlluContents.length > 1)
        {
            return (
                <div className={cssLessonIllustration.divPageIconArea}>
                    <div className={cssLessonIllustration.divPageIconContainer}>
                        {props.LUInfo.IlluContents.map((Result, Index) =>
                            <div key={Index} className={cssLessonIllustration.divPageIconBlock}>
                                <div className={GetPageIconCls(Index, currentPageIndex)}></div>
                            </div>
                        )}
                    </div>
                </div>
            )
        }
        else
        {
            return null
        }
    }

    function RenderMainArea()
    {
        console.log(COMP_NAME + ".RenderMainArea: ")
        console.log("props.LUInfo.IlluContents: ", props.LUInfo.IlluContents)

        return (
            <>
                {RenderHeaderLeftArea()}
                {RenderHeaderRightArea()}
                <div className={cssLessonIllustration.divContentArea}>
                    <div className={cssLessonIllustration.divScrollArea}>
                        {RenderContentListWrapper(currentPageIndex)}
                    </div>
                </div>
                {RenderPageIcon()}
            </>
        )

    }

    return (
        RenderMainArea()
    )
    // #endregion Render
}
export default LessonIllustration